import * as React from 'react';
import { Edit, Form, Toolbar } from 'react-admin';
import { CardContent } from '@mui/material';

import { AccountInputs } from './AccountInputs';

import { AccountAside } from './AccountAside';

export const AccountEdit = () => (
    <Edit
        aside={<AccountAside link="show" />}
        actions={false}
        redirect="show"
        transform={values => {
            // add https:// before website if not present
            if (values.website && !values.website.startsWith('http')) {
                values.website = `https://${values.website}`;
            }
            return values;
        }}
    >
        <Form>
            <CardContent>
                <AccountInputs />
            </CardContent>
            <Toolbar />
        </Form>
    </Edit>
);
